export const QA_NAME_MODAL_WIZARD = 'wizard'
